export const walletAccountsQueryKey = ["wallet-accounts"];